// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__2jr8l","header":"Messages_header__1FB_y"};